export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "add-group": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Groupe"])},
        "add-prop": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Condition"])},
        "group-and": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Et"])},
        "group-or": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ou"])},
        "condition-type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type de condition"])},
        "delete-group": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimer le groupe"])}
      },
      "en": {
        "add-group": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Group"])},
        "add-prop": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Condition"])},
        "group-and": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["And"])},
        "group-or": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Or"])},
        "condition-type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Condition type"])},
        "delete-group": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete group"])}
      }
    }
  })
}
